const ONBOARDING_TASK_MODE = '/b/onboarding/task';

/** 减少几次取值 */
let isOnboardingTaskMode: boolean | undefined = undefined;
/** 当前是不是演示模式 */
export const checkIsOnboardingTaskMode = () => {
  try {
    return (
      window !== window.parent &&
      window.parent.location.host === window.location.host &&
      window.parent.location.pathname === ONBOARDING_TASK_MODE
    );
  } catch {
    return false;
  }
};
/** 当前是不是演示模式 */
export const getIsOnboardingTaskMode = () =>
  isOnboardingTaskMode ?? (isOnboardingTaskMode = checkIsOnboardingTaskMode());

/** 当前是不是演示模式页面 */
export const getIsOnboardingTaskModePage = () => location.pathname === ONBOARDING_TASK_MODE;
export const ONBOARDING_OPERATION_TASK_MODE = '/b/onboarding/operation-task';
export const getIsOnboardingOperationTaskModePage = () =>
  window.location.pathname === ONBOARDING_OPERATION_TASK_MODE;
export const getIsOnboardingOperationTaskPage = () =>
  location.pathname === ONBOARDING_OPERATION_TASK_MODE;
/** 是不是在onboarding新手任务相关的页面 */
export const getIsOnboardingTaskRelated = () =>
  getIsOnboardingTaskMode() ||
  getIsOnboardingTaskModePage() ||
  getIsOnboardingOperationTaskModePage();
/** 减少几次取值 */
let isOnboardingOperationTaskMode: boolean | undefined = undefined;
/** 当前是不是演示模式 */
const checkIsOnboardingOperationTaskMode = () => {
  try {
    return (
      window !== window.parent &&
      window.parent.location.host === window.location.host &&
      window.parent.location.pathname === ONBOARDING_OPERATION_TASK_MODE
    );
  } catch {
    return false;
  }
};
export const getIsOnboardingOperationTaskMode = () =>
  isOnboardingOperationTaskMode ??
  (isOnboardingOperationTaskMode = checkIsOnboardingOperationTaskMode());
